module.exports = __webpack_public_path__ + "img/Peugeot.c6ca8115.png";